import { render, staticRenderFns } from "./input-rate-article.vue?vue&type=template&id=523e8702"
import script from "./input-rate-article.vue?vue&type=script&lang=js"
export * from "./input-rate-article.vue?vue&type=script&lang=js"
import style0 from "./input-rate-article.vue?vue&type=style&index=0&id=523e8702&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports